import * as React from 'react'

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  style?: React.CSSProperties
}

interface AvatarImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string
  style?: React.CSSProperties
}

interface AvatarFallbackProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  style?: React.CSSProperties
}

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ className, style, ...props }, ref) => (
    <div
      ref={ref}
      className={className}
      style={{
        position: 'relative',
        display: 'flex',
        height: '40px',
        width: '40px',
        flexShrink: 0,
        overflow: 'hidden',
        borderRadius: '50%',
        ...style,
      }}
      {...props}
    />
  )
)
Avatar.displayName = 'Avatar'

const AvatarImage = React.forwardRef<HTMLImageElement, AvatarImageProps>(
  ({ className, alt = '', style, ...props }, ref) => (
    <img
      ref={ref}
      className={className}
      style={{
        aspectRatio: '1',
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        ...style,
      }}
      alt={alt}
      {...props}
    />
  )
)
AvatarImage.displayName = 'AvatarImage'

const AvatarFallback = React.forwardRef<HTMLDivElement, AvatarFallbackProps>(
  ({ className, style, ...props }, ref) => (
    <div
      ref={ref}
      className={className}
      style={{
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: '#f3f4f6',
        ...style,
      }}
      {...props}
    />
  )
)
AvatarFallback.displayName = 'AvatarFallback'

export { Avatar, AvatarImage, AvatarFallback }
